import { cn as e } from "../shared/utils.js";
import { Badge as t } from "../badge/badge.js";
import { buttonVariants as n } from "../button/primitive/button.js";
import { useTranslation as r } from "../i18n/hooks.js";
import { breakpointQueries as i } from "../shared/breakpoints.js";
import { useMediaQuery as a } from "../shared/hooks/use-media-query.js";
import { Menu as o } from "../menu/index.js";
import { Skeleton as s } from "../skeleton/skeleton.js";
import { TooltipTextOverflow as c } from "../tooltip/tooltip-text-overflow.js";
import { ChevronDownIcon as l, ChevronLeftIcon as u, ChevronRightIcon as d } from "@systemeio/icons";
import { forwardRef as f } from "react";
import { jsx as p, jsxs as m } from "react/jsx-runtime";
import { useRender as h } from "@base-ui/react/use-render";
import { cva as g } from "class-variance-authority";
//#region src/breadcrumbs/breadcrumbs.tsx
var _ = 4, v = 2, y = g("text-base inline-flex min-w-0 items-center gap-1", {
	defaultVariants: { state: "default" },
	variants: { state: {
		default: "text-text-tertiary [&_svg]:text-icon-tertiary",
		active: "text-text-link [&_svg]:text-text-link"
	} }
}), b = g("transition-base", {
	defaultVariants: { state: "default" },
	variants: { state: {
		default: "hover:text-text-secondary hover:[&_svg]:text-icon-primary",
		active: "hover:text-text-link"
	} }
}), x = f(({ "aria-label": t = "Breadcrumb", className: n, ...r }, i) => /* @__PURE__ */ p("nav", {
	ref: i,
	"aria-label": t,
	className: e("min-w-0", n),
	...r
})), S = f(({ className: t, ...n }, r) => /* @__PURE__ */ p("ol", {
	ref: r,
	className: e("-m-1 flex min-w-0 flex-nowrap items-center gap-2 overflow-hidden p-1 whitespace-nowrap", t),
	...n
})), C = f(({ className: t, ...n }, r) => /* @__PURE__ */ p("li", {
	ref: r,
	className: e("flex min-w-0 shrink items-center gap-1.5", t),
	...n
})), w = f(({ className: t, render: n, state: r, ...i }, a) => {
	let o = {
		className: e(y({ state: r }), b({ state: r }), "outline-none focus-visible:focus-ring-primary", t),
		"data-slot": "breadcrumb-link",
		"data-testid": "breadcrumb-link",
		...i
	};
	return h({
		defaultTagName: "a",
		props: o,
		ref: a,
		render: n
	});
}), T = f(({ className: t, render: n, ...r }, i) => {
	let a = {
		className: e("outline-none", t),
		"data-slot": "breadcrumb-menu-link",
		"data-testid": "breadcrumb-menu-link",
		...r
	};
	return h({
		defaultTagName: "a",
		props: a,
		ref: i,
		render: n
	});
}), E = f(({ className: t, state: n, ...r }, i) => /* @__PURE__ */ p("span", {
	ref: i,
	className: e("text-text-tertiary [&_svg]:text-icon-tertiary inline-flex min-w-0 items-center gap-1", t),
	...r
})), D = f(({ className: t, open: n, ...r }, i) => /* @__PURE__ */ p("span", {
	ref: i,
	className: e("text-text-secondary hover:bg-bg-secondary transition-base flex h-5 min-w-6 items-center justify-center rounded-sm px-1.5 text-base leading-none", n && "bg-bg-secondary text-text-link", t),
	...r,
	children: "..."
})), O = f(({ className: t, state: n, ...r }, i) => /* @__PURE__ */ p("span", {
	ref: i,
	className: e(y({
		className: t,
		state: n
	})),
	...r
}));
function k({ icon: t, className: n, ...r }) {
	return /* @__PURE__ */ p(t, {
		className: e("transition-base size-4 shrink-0", n),
		...r
	});
}
var A = f(({ children: t = /* @__PURE__ */ p(d, { className: "size-4" }), className: n, ...r }, i) => /* @__PURE__ */ p("span", {
	ref: i,
	"aria-hidden": "true",
	className: e("text-icon-tertiary flex shrink-0 items-center", n),
	...r,
	children: t
}));
function j({ item: t, isCurrent: n }) {
	if (t.loading) {
		let { className: n, ...r } = t.skeletonProps ?? {};
		return /* @__PURE__ */ p(s, {
			className: e("h-5 w-24", n),
			...r
		});
	}
	return n || !t.href ? /* @__PURE__ */ m(V.Text, {
		...t.textProps,
		"aria-current": n ? "page" : void 0,
		state: n ? "active" : "default",
		children: [t.icon && /* @__PURE__ */ p(V.Icon, {
			icon: t.icon,
			...t.iconProps
		}), /* @__PURE__ */ p(c, { children: t.label })]
	}) : /* @__PURE__ */ m(V.Link, {
		href: t.href,
		...t.linkProps,
		state: "default",
		children: [t.icon && /* @__PURE__ */ p(V.Icon, {
			icon: t.icon,
			...t.iconProps
		}), /* @__PURE__ */ p(c, { children: t.label })]
	});
}
function M(e) {
	let t = e.findIndex((e) => e.current);
	return t >= 0 ? t : e.length - 1;
}
function N(n, r) {
	return n.loading ? /* @__PURE__ */ p(s, {
		...n.menuSkeletonProps,
		className: e("h-4 w-full", n.menuSkeletonProps?.className)
	}) : /* @__PURE__ */ m("span", {
		className: "flex w-full min-w-0 items-center gap-2",
		children: [/* @__PURE__ */ m(V.MenuText, {
			className: "text-text-primary [&_svg]:text-icon-primary min-w-0 flex-1",
			children: [n.icon && /* @__PURE__ */ p(V.Icon, {
				icon: n.icon,
				...n.iconProps
			}), /* @__PURE__ */ p(c, { children: n.label })]
		}), r?.showCurrentBadge ? /* @__PURE__ */ p(t, {
			color: "outlinedGray",
			shape: "rounded",
			size: "md",
			children: r.currentBadgeLabel
		}) : null]
	});
}
function P(e, t, n) {
	return e.map((e, r) => {
		let i = e.id ?? `path-${r}`, a = r === t, o = e.loading;
		return a ? {
			id: i,
			label: N(e, {
				showCurrentBadge: !0,
				currentBadgeLabel: n
			}),
			className: "bg-palette-blue-bg",
			closeOnSelect: !1,
			disabled: o || void 0
		} : e.href && !o ? {
			id: i,
			type: "link",
			label: N(e),
			render: /* @__PURE__ */ p(V.MenuLink, {
				href: e.href,
				...e.linkProps
			})
		} : {
			id: i,
			disabled: !0,
			label: N(e),
			closeOnSelect: !1
		};
	});
}
function F({ items: t, menuProps: n }) {
	let { triggerProps: r, ...i } = n ?? {};
	return /* @__PURE__ */ p(o, {
		align: "start",
		...i,
		triggerProps: {
			"aria-label": "Show hidden breadcrumbs",
			...r
		},
		trigger: ({ open: e }) => /* @__PURE__ */ p(V.MenuTrigger, {
			"aria-hidden": "true",
			open: e
		}),
		items: t.map((t, n) => {
			let r = t.loading, i = t.id ?? `collapsed-${n}`, a = r ? /* @__PURE__ */ p(s, {
				...t.menuSkeletonProps,
				className: e("h-4 w-full", t.menuSkeletonProps?.className)
			}) : /* @__PURE__ */ m(V.MenuText, { children: [t.icon && /* @__PURE__ */ p(V.Icon, {
				icon: t.icon,
				...t.iconProps
			}), /* @__PURE__ */ p(c, { children: t.label })] });
			return t.href && !r ? {
				id: i,
				type: "link",
				label: a,
				render: /* @__PURE__ */ p(V.MenuLink, {
					href: t.href,
					...t.linkProps
				})
			} : {
				id: i,
				disabled: r || void 0,
				label: a
			};
		})
	});
}
function I({ item: t }) {
	let { render: r, className: i, ...a } = t.linkProps ?? {};
	return h({
		defaultTagName: "a",
		props: {
			...a,
			href: t.href,
			"aria-label": "Go to previous page",
			"data-slot": "breadcrumbs-back",
			"data-testid": "breadcrumbs-back",
			className: e(n({
				variant: "ghost-gray",
				size: "icon-sm"
			}), "shrink-0", i),
			children: /* @__PURE__ */ p(u, { className: "size-4" })
		},
		render: r
	});
}
function L({ open: t, item: n }) {
	return /* @__PURE__ */ m("span", {
		"data-slot": "breadcrumbs-mobile-current",
		"data-testid": "breadcrumbs-mobile-current",
		className: "text-text-link inline-flex max-w-full min-w-0 items-center gap-1 text-base",
		"aria-current": "page",
		children: [n.loading ? /* @__PURE__ */ p(s, {
			...n.skeletonProps,
			className: e("h-5 w-24", n.skeletonProps?.className)
		}) : /* @__PURE__ */ p(c, {
			className: "text-text-link",
			children: n.label
		}), /* @__PURE__ */ p(l, {
			className: e("text-text-link transition-base size-4 shrink-0 transition-transform", t && "rotate-180"),
			"aria-hidden": "true"
		})]
	});
}
function R({ items: t, menuProps: n, currentBadgeLabel: r, navigationPathTitle: i, ...a }) {
	let s = M(t), c = t[s], l = s > 0 ? t[s - 1] : void 0, u = !!(l?.href && !l.loading), { triggerProps: d, drawerTitle: f = i, ...h } = n ?? {};
	return c ? /* @__PURE__ */ p(V.Root, {
		...a,
		children: /* @__PURE__ */ m("div", {
			className: "flex min-w-0 items-center gap-1",
			children: [u && l ? /* @__PURE__ */ p(I, { item: l }) : null, /* @__PURE__ */ p(o, {
				align: "start",
				drawerTitle: f,
				...h,
				triggerProps: {
					...d,
					className: e("min-w-0 max-w-full", d?.className)
				},
				trigger: ({ open: e }) => /* @__PURE__ */ p(L, {
					open: e,
					item: c
				}),
				items: P(t, s, r)
			})]
		})
	}) : /* @__PURE__ */ p(V.Root, { ...a });
}
function z({ items: e, listProps: t, menuProps: n, visibleEdgeItemsCount: r = v, visibleItemsCount: i = _, ...a }) {
	let o = Math.min(r, Math.floor(i / 2)), s = e.length > i, c = s ? e.slice(0, o) : e, l = s ? e.slice(o, o > 0 ? -o : void 0) : [], u = s && o > 0 ? e.slice(-o) : [];
	return /* @__PURE__ */ p(V.Root, {
		...a,
		children: /* @__PURE__ */ m(V.List, {
			...t,
			children: [
				c.map((t, n) => {
					let r = n === e.length - 1, i = t.current ?? r;
					return /* @__PURE__ */ m(V.Item, {
						...t.itemProps,
						children: [n > 0 && /* @__PURE__ */ p(V.Separator, { ...t.separatorProps }), /* @__PURE__ */ p(j, {
							item: t,
							isCurrent: i
						})]
					}, t.id ?? n);
				}),
				s && /* @__PURE__ */ m(V.Item, { children: [/* @__PURE__ */ p(V.Separator, { ...l[0]?.separatorProps }), /* @__PURE__ */ p(F, {
					items: l,
					menuProps: n
				})] }),
				u.map((t, n) => {
					let r = e.length - o + n, i = r === e.length - 1, a = t.current ?? i;
					return /* @__PURE__ */ m(V.Item, {
						...t.itemProps,
						children: [r > 0 && /* @__PURE__ */ p(V.Separator, { ...t.separatorProps }), /* @__PURE__ */ p(j, {
							item: t,
							isCurrent: a
						})]
					}, t.id ?? r);
				})
			]
		})
	});
}
x.displayName = "Breadcrumbs.Root", S.displayName = "Breadcrumbs.List", C.displayName = "Breadcrumbs.Item", w.displayName = "Breadcrumbs.Link", T.displayName = "Breadcrumbs.MenuLink", E.displayName = "Breadcrumbs.MenuText", D.displayName = "Breadcrumbs.MenuTrigger", O.displayName = "Breadcrumbs.Text", k.displayName = "Breadcrumbs.Icon", A.displayName = "Breadcrumbs.Separator";
function B({ items: e, listProps: t, menuProps: n, currentBadgeLabel: o, navigationPathTitle: s, visibleEdgeItemsCount: c = v, visibleItemsCount: l = _, ...u }) {
	let { t: d } = r(), f = o ?? d("public_pages_purchase.breadcrumbs.current", { defaultValue: "Current" }), m = s ?? d("public_pages_purchase.breadcrumbs.navigation_path", { defaultValue: "Navigation path" });
	return a(i.isMobile, { initializeWithValue: !1 }) ? /* @__PURE__ */ p(R, {
		items: e,
		menuProps: n,
		currentBadgeLabel: f,
		navigationPathTitle: m,
		...u
	}) : /* @__PURE__ */ p(z, {
		items: e,
		listProps: t,
		menuProps: n,
		visibleEdgeItemsCount: c,
		visibleItemsCount: l,
		...u
	});
}
var V = Object.assign(B, {
	Root: x,
	List: S,
	Item: C,
	Link: w,
	MenuLink: T,
	MenuText: E,
	MenuTrigger: D,
	Text: O,
	Icon: k,
	Separator: A
});
//#endregion
export { V as Breadcrumbs };
